export default __webpack_public_path__ + "static/media/circle.bb8bdcd7.svg";